import { useState, useEffect, useRef } from 'react';

const SLIDES_DESKTOP = ['/profil.jpg', '/croustycarousel.jpg'];
const SLIDES_MOBILE  = ['/profil.jpg', '/croustymobile.png'];
const INTERVAL = 8000;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 640);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 640px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isMobile;
}

export default function Carousel() {
  const isMobile = useIsMobile();
  const SLIDES = isMobile ? SLIDES_MOBILE : SLIDES_DESKTOP;
  const [index, setIndex] = useState(0);
  const [animated, setAnimated] = useState(true);
  const total = SLIDES.length;
  const extended = [...SLIDES, SLIDES[0]];

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimated(true);
      setIndex(prev => prev + 1);
    }, INTERVAL);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (index === total) {
      const timeout = setTimeout(() => {
        setAnimated(false);
        setIndex(0);
      }, 600);
      return () => clearTimeout(timeout);
    }
  }, [index, total]);

  const current = index % total;
  const touchStartX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(delta) > 50) {
      setAnimated(true);
      if (delta > 0) {
        setIndex(prev => prev + 1);
      } else {
        setIndex(prev => prev <= 0 ? total - 1 : prev - 1);
      }
    }
    touchStartX.current = null;
  };

  return (
    <div
      className="carousel-root"
      style={{ position: 'relative', overflow: 'hidden', width: '100%' }}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div
        style={{
          display: 'flex',
          width: `${extended.length * 100}%`,
          height: '100%',
          transform: `translateX(-${(index * 100) / extended.length}%)`,
          transition: animated ? 'transform 0.6s ease-in-out' : 'none',
        }}
      >
        {extended.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            className="carousel-img"
            style={{
              width: `${100 / extended.length}%`,
              height: '100%',
              objectFit: 'fill',
              display: 'block',
              flexShrink: 0,
            }}
          />
        ))}
      </div>

      <div style={{ position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '8px' }}>
        {SLIDES.map((_, i) => (
          <div
            key={i}
            style={{
              width: '200px',
              height: '3px',
              borderRadius: '2px',
              backgroundColor: '#fff',
              opacity: current === i ? 1 : 0.4,
              transition: 'opacity 0.4s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
}
